import types from './types';

import {
  getAllAlerts,
  addAlert,
  updateAlert,
  deleteAlert,
  getAlertLoads,
  changeAlertStatus,
  clearMathesApi,
  changeEquipmentApi,
  addAlertFromOtherWhere,
} from '~/api/alert';
import {pick} from 'lodash';

import create, {prepare} from '~/misc/create';
import {push as changeURL} from 'react-router-redux';
import * as urls from '~/routing/urls';
import findIndex from 'lodash/findIndex';
import * as equipment from '~/misc/equipment';
import { subDays, eachDay, startOfDay } from 'date-fns';
import { multiple_init_select, multiple_clear } from '~/modules/geosearch/actions';
import { promiseAction } from '~/misc/dispatch';

let times = null;

// 将新增/更新的alert插入/更换
const updateList = (data, dispatch, getState, key) => {
  const list = getState().alert.list;
  if (key !== undefined) {
    // update
    list[key] = data;
  } else {
    // add
    list.push(data);
  }
  dispatch(create(types.SET_ALL_ALERTS, {list}));
}

export const alert = prepare(types.ALERT);

export const changeStatus = ({idList, type}) => ((dispatch, getState) => {
  const list = getState().alert.list;
  idList.forEach(id => {
    const item = list.filter(li => li.id === id)[0];
    const key = findIndex(list, {'id': id});
    if(item){
      const i = pick(item, ['pickup_start', 'pickup_end', 'from_location', 'enabled', 'to_location', 'load_size', 'weight_max', 'length', 'user_id', 'equipment']);
      if(type === 'change status'){
        i.enabled = !i.enabled;
      }else if(type === 'clear'){
        i.count = 0;
      }
      changeAlertStatus(getState, item.id, i).then(res => {
        updateList(res, dispatch, getState, key);
      })
    }
  })
});

export const clearMathesNum = (idList, equipment) => (dispatch, getState) => {
  clearMathesApi(getState, idList).then(() => {
    dispatch(getAlertLists(equipment));
  })
};

export const changeEquipment = (val) => (dispatch, getState) => {
  dispatch(getAlertLists(val));
}

export const changeSelected = (id) => ((dispatch, getState) => {
  dispatch(create(types.LIST_CHANGE_SELECTED, {id}));
});

export const changeSelectedAll = () =>  ((dispatch, getState) => {
  dispatch(create(types.LIST_CHANGE_SELECTED_ALL));
});


export const getAlertLists = (type) => ((dispatch, getState) => {
  dispatch(create(types.SET_ALL_ALERTS_START))
  getAllAlerts(getState, type).then(res => {
    dispatch(create(types.SET_ALL_ALERTS, {
      list: res.results,
      equipment: res.equipment,
      pushAvailable: res.push_available,
      noneSelected: true
    }));
  })
})
export const checkLIneAlert = () => ((dispatch, getState) => {
  if(!times){
    times = setInterval(() => {
      getAllAlerts(getState , {equipment: 'all'}).then(res => {
        dispatch(create(types.SET_ALL_ALERTS, {
          list: res.results
        }));
      })
    }, 300000);
  }
})

export const clearCheckInterval = () => {
  clearInterval(times);
}

export const removeAlert = (idList) => ((dispatch, getState) => {
  idList.forEach(id => {
    deleteAlert(getState, id).then(() => {
      dispatch(create(types.DELETE_ALERT, {id}));
      dispatch(getAlertLists());
    });
  })
})

// 新增
export const addSubmit = (formDate) => ((dispatch, getState) => {
  addAlert(getState, formDate).then(res => {
    updateList(res, dispatch, getState);
    dispatch(changeURL(`${urls.ALERT}/${urls.ALERTURL.AlertList}`));
  })
})


export const addAlertFromOtherWhereAction = (formDate) => (dispatch, getState) => {
  const user = getState().user
  if(!user.isLoggedIn || !formDate.origin.name || !formDate.date.length) return;
  promiseAction(
    dispatch,
    getState,
    types.ALERT_ADD_FROM_OTHERWHERE,
    addAlertFromOtherWhere(getState, formDate)
  )
}
  


// 更新
export const updateSubmit = (formDate, id) => ((dispatch, getState) => {
  const list = getState().alert.list;
  const key = findIndex(list, {'id': Number(id)});
  const origin = list[key];
  updateAlert(getState, formDate, id, origin.enabled).then(res => {
    updateList(res, dispatch, getState, key);
    dispatch(changeURL(`${urls.ALERT}/${urls.ALERTURL.AlertList}`));
  })
})

// 初始化form
export const formateForm = (id) => (dispatch, getState) => {
  const list = getState().alert.list;
  const key = findIndex(list, {'id': Number(id)});
  if (key === -1) {
    dispatch(changeURL(`${urls.ALERT}/${urls.ALERTURL.AlertList}`));
    return;
  }
  const origin = list[key];
  const result = {
    id: id,
    origin: origin.from_location.address,
    dho: origin.from_location.deadhead,
    dhd: origin.to_location && origin.to_location.city && origin.to_location.city[0] && origin.to_location.city[0].deadhead,
    date: eachDay(startOfDay(origin.pickup_start), startOfDay(origin.pickup_end)),
    loadSize: origin.load_size,
    weight: origin.weight_max > 0 ? origin.weight_max : '',
    length: origin.length > 0 ? origin.length : '',
    equipment: origin.equipment ? [equipment.humanLowerCaseToId[origin.equipment]] : ['F'] 
  }
  const originSelected = {
    hasFocus: false,
    placeValue: {
      lat: origin.from_location.lat,
      lng: origin.from_location.lng,
      name: origin.from_location.address,
      state: origin.from_location.state,
      is_city: true
    }
  }
  const destinationSelected = [];
  if (origin.to_location) {
    if (origin.to_location.city) {
      origin.to_location.city.forEach(ele => {
        destinationSelected.push({
          isShow: false,
          isSelect: true,
          placeValue: {
            lat: ele.lat,
            lng: ele.lng,
            name: ele.address,
            is_city: true
          }
        })
      });
    }
    if (origin.to_location.state) {
      origin.to_location.state.forEach(ele => {
        destinationSelected.push({
          isShow: false,
          isSelect: true,
          placeValue: {
            state: ele,
            name: ele,
          }
        })
      })
    }
  }
  dispatch(create(types.INIT_ALERT_FORM, {result}));
  dispatch(multiple_init_select('alert:origin-field', originSelected));
  dispatch(multiple_init_select('alert:destination-field', {selected: destinationSelected}));
}

// 获取到alert匹配的loads
export const getLoads = ({id, equipment}) => (dispatch, getState) => {
  dispatch(create(types.ALERT_LOADS_LIST_LOADING, {}));
  getAlertLoads(getState, id, equipment).then(res => {
    dispatch(create(types.ALERT_LOADS_LIST, {list: res}));
    dispatch(getAlertLists());
  })
}

export const destroyForm = () => (dispatch, getState) => {
  dispatch(multiple_clear());
  dispatch(create(types.INIT_ALERT_FORM, {result: {}}));
}



// WEBPACK FOOTER //
// ./src/modules/alert/actions.js